import {BrowserRouter, Routes, Route} from 'react-router'

import Home from './Components/Home';
import Login from './Components/Login';
import ProtectedRoutes from './Components/utils/ProtectedRoutes';
import { AuthProvider } from './Components/utils/AuthContext';

function App() {
  return (
    <AuthProvider >
      <BrowserRouter>
        <Routes>
          {/* Protected Routes */}
          <Route element={<ProtectedRoutes />}>
            <Route element={<Home />} path='/' />
          </Route>
          {/* Free to access Routes */}
          <Route element={<Login />} path='/login' />      
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
